import { render, staticRenderFns } from "./RepairApply.vue?vue&type=template&id=05c585c8&scoped=true"
import script from "./RepairApply.vue?vue&type=script&lang=js"
export * from "./RepairApply.vue?vue&type=script&lang=js"
import style0 from "./RepairApply.vue?vue&type=style&index=0&id=05c585c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c585c8",
  null
  
)

export default component.exports